import { Encodable } from "../Encodable";

import { BaseEncoder } from "../../encoder/BaseEncoder";

export class ConcreteEncodable implements Encodable {
  majorRevision: number = 1;
  minorRevision: number = 1;
  innerEncoding: boolean = true;
  // fixed by implementors of Encodable
  enType: string = "com.bcdfx.broker.ConcreteEncodable";
  // set from message received by BaseEncoder
  encodableType: string = "com.bcdfx.broker.ConcreteEncodable";
  encoder: BaseEncoder;
  _extendedInfo: Map<string, string> | null;
  sessionOnly: string | null = null;

  public isInnerEncoding(): boolean {
    return this.innerEncoding;
  }
  public setInnerEncoding(val: boolean): void {
    this.innerEncoding = val;
  }
  public setEncodableType(val: string) {
    this.encodableType = val;
  }
  public getEncoder(): BaseEncoder {
    return this.encoder;
  }
  public validateInbound() {}

  public validateOutbound() {}

  public isExtendedInfoEmpty(): boolean {
    return this._extendedInfo == null;
  }

  public get extendedInfo(): Map<string, string> {
    if (this._extendedInfo == null) {
      this._extendedInfo = new Map<string, string>();
    }
    return this._extendedInfo;
  }

  public set extendedInfo(extendedInfo: Map<string, string>) {
    if (extendedInfo == null || extendedInfo.size == 0) {
      this._extendedInfo = null;
    } else {
      this._extendedInfo = extendedInfo;
    }
  }
}
